import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { UsersService } from '../users/services/users.service';

// const ELEMENT_DATA = [
//   {
//     type: 'test',
//     name: 'Refinance my debt',
//     amount: '200$',
//     date: '26/12/20',
//     status: 'won',
//   },
//   {
//     type: 'test',
//     name: 'Buy a car or equipment',
//     amount: '200$',
//     date: '26/12/20',
//     status: 'won',
//   },
//   {
//     type: 'test',
//     name: 'Acquire a business or refinance business debt',
//     amount: '2090$',
//     date: '26/12/20',
//     status: 'won',
//   },
//   {
//     type: 'test',
//     name: 'Refinance my debt',
//     amount: '200$',
//     date: '26/12/20',
//     status: 'won',
//   },
//   {
//     type: 'test',
//     name: 'Buy a car or equipment',
//     amount: '200$',
//     date: '26/12/20',
//     status: 'won',
//   },
//   {
//     type: 'test',
//     name: 'Acquire a business or refinance business debt',
//     amount: '2090$',
//     date: '26/12/20',
//     status: 'won',
//   },
// ];

@Component({
  selector: 'app-completed-opportunities',
  templateUrl: './completed-opportunities.component.html',
  styleUrls: ['./completed-opportunities.component.scss'],
})
export class CompletedOpportunitiesComponent implements OnInit {
  displayedColumns: string[] = ['name', 'amount', 'date', 'status'];
  dataSourceTable = [];
  public token;
  contactId: string;
  noOpportunity = false;
  accountId: string;
  constructor(
    private userService: UsersService,
    private auth: AuthenticationService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.contactId = this.auth.getPrimaryUserId();
    this.accountId = this.auth.getUserAccountId();
    this.token = this.auth.getUserAccessToken();
    this.getCompletedApplications();
  }

  getCompletedApplications() {
    this.loadingService.startLoading();
    this.userService
      .getCompletedOpportunity(this.token, this.accountId)
      .subscribe(
        (response) => {
          this.dataSourceTable = [];
          this.loadingService.stopLoading();
          // console.log(response);
          if (response) {
            if (response.data.length == 0) {
              this.noOpportunity = true;
            }
            response.data.forEach((element) => {
              const opprtunityName = element.name.split(' - ');
              const newData = {
                type: element.new_transactiontype_Formatted,
                name: opprtunityName[1],
                amount: element.budgetamount,
                date: element.createdon_Formatted,
                status: element.statecode_Formatted,
              };
              this.dataSourceTable.push(newData);
            });
            if (this.dataSourceTable.length == 0) {
              this.auth.showSnackBarMsg('Currently, there is no completed application.', 5000)
            }
          }
        },
        (error) => {
          console.log(error);
          this.loadingService.stopLoading();
          this.auth.showSnackBarMsg('Please Select a Valid Company!')
        }
      );
  }

  onBack() {
    const backUrl = this.auth.getbackurl();
    // console.log(backUrl);
    if (backUrl) {
      // this.router.navigate([`${backUrl}`]);
      this.auth.gotoUrl(`${backUrl}`);
    } else {
      this.auth.showSnackBarMsg('You can not go back, Please login again')
    }
  }
}
